module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }